// Arquivo gerado por scripts/generate-build-info.js. Nao edite manualmente.
export const BUILD_INFO = {
  "version": "10.0.1",
  "revision": "a0cd7783",
  "builtAt": "2026-10-19T19:18:53.061Z",
  "buildId": "10.0.1-a0cd7783-2026-10-19T19:18:53.061Z"
};
